(function () {
  var pendingKey = 'sevenvnWaitlistSuccessPending';
  var contextKey = 'sevenvnWaitlistSuccessContext';
  var modal;
  var dialog;
  var lastFocus;
  var observer;
  var initialized = false;
  var submittingForms = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function normalizeText(value) {
    return (value || '').toString().replace(/\s+/g, ' ').trim();
  }

  function getText(value) {
    return normalizeText(value).toLowerCase();
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function fieldSignature(field) {
    var parts = [
      field.name,
      field.id,
      field.getAttribute('aria-label'),
      field.getAttribute('placeholder'),
      field.getAttribute('data-label')
    ];
    var label;

    if (field.id) {
      label = field.form && field.form.querySelector('label[for="' + cssEscape(field.id) + '"]');
      if (label) {
        parts.push(label.textContent);
      }
    }

    label = field.closest('label');
    if (label) {
      parts.push(label.textContent);
    }

    var parent = field.parentElement;
    var depth = 0;

    while (parent && parent !== field.form && depth < 3) {
      label = parent.querySelector('label, [class*="label"], [class*="Label"]');
      if (label) {
        parts.push(label.textContent);
      }

      parent = parent.parentElement;
      depth += 1;
    }

    return getText(parts.join(' '));
  }

  function findField(form, tokens, selector) {
    var fields = form ? form.querySelectorAll(selector) : [];
    var i;
    var tokenIndex;
    var signature;

    for (i = 0; i < fields.length; i += 1) {
      signature = fieldSignature(fields[i]);

      for (tokenIndex = 0; tokenIndex < tokens.length; tokenIndex += 1) {
        if (signature.indexOf(tokens[tokenIndex]) !== -1) {
          return fields[i];
        }
      }
    }

    return null;
  }

  function getFieldValue(field) {
    var selectedOption;

    if (!field) {
      return '';
    }

    if (field.tagName === 'SELECT') {
      selectedOption = field.options[field.selectedIndex];
      return normalizeText(
        (selectedOption && (selectedOption.textContent || selectedOption.value)) || field.value
      );
    }

    return normalizeText(field.value);
  }

  function isPlaceholderValue(value) {
    var text = getText(value);

    return (
      !text ||
      text === 'select one' ||
      text === 'select' ||
      text === 'training style' ||
      text === 'select training style' ||
      text === 'choose training style' ||
      text === 'please select'
    );
  }

  function getWaitlistContext(form) {
    var emailField = form.querySelector('input[type="email"], input[name="email"], input[name*="[email]"]');
    var firstNameField = findField(
      form,
      ['first name', 'firstname', 'first_name', 'fname'],
      'input:not([type="hidden"]), textarea'
    );
    var trainingStyleField = findField(
      form,
      ['training style', 'training_style', 'training-style', 'training'],
      'select, input:not([type="hidden"])'
    );
    var trainingStyle = getFieldValue(trainingStyleField);

    if (firstNameField === emailField) {
      firstNameField = null;
    }

    return {
      email: getFieldValue(emailField),
      firstName: getFieldValue(firstNameField),
      trainingStyle: isPlaceholderValue(trainingStyle) ? '' : trainingStyle
    };
  }

  function storeWaitlistContext(form) {
    try {
      sessionStorage.setItem(contextKey, JSON.stringify(getWaitlistContext(form)));
    } catch (error) {
      sessionStorage.removeItem(contextKey);
    }
  }

  function readWaitlistContext() {
    var stored = sessionStorage.getItem(contextKey);

    if (!stored) {
      return {};
    }

    try {
      return JSON.parse(stored) || {};
    } catch (error) {
      return {};
    }
  }

  function buildContextMessage(context) {
    var message = 'We received your email and will send launch updates for 7VN Clean Pre Workout.';

    if (context.trainingStyle) {
      message += ' We will tailor updates around ' + context.trainingStyle + ' so you know when CLEAN is ready for your training.';
    }

    return message;
  }

  function applyModalContext() {
    var context = readWaitlistContext();
    var title = modal && modal.querySelector('[data-sevenvn-waitlist-title]');
    var message = modal && modal.querySelector('[data-sevenvn-waitlist-message]');

    if (title) {
      title.textContent = context.firstName ? 'Thanks, ' + context.firstName + ". You're on the list." : "You're on the list.";
    }

    if (message) {
      message.textContent = buildContextMessage(context);
    }
  }

  function hasEmailField(form) {
    return !!form.querySelector('input[type="email"], input[name="email"], input[name*="[email]"]');
  }

  function hasWaitlistMarker(element) {
    var current = element;
    var depth = 0;

    while (current && depth < 7) {
      var marker = [
        current.id,
        current.className,
        current.getAttribute && current.getAttribute('data-section-type'),
        current.getAttribute && current.getAttribute('aria-label')
      ].join(' ');
      marker = getText(marker);

      if (
        marker.indexOf('waitlist') !== -1 ||
        marker.indexOf('earlyaccess') !== -1 ||
        marker.indexOf('early-access') !== -1 ||
        marker.indexOf('newsletter') !== -1
      ) {
        return true;
      }

      current = current.parentElement;
      depth += 1;
    }

    return false;
  }

  function isWaitlistForm(form) {
    if (!form || form.tagName !== 'FORM' || !hasEmailField(form)) {
      return false;
    }

    if (form.hasAttribute('data-sevenvn-waitlist-form')) {
      return true;
    }

    if (hasWaitlistMarker(form)) {
      return true;
    }

    var submitText = Array.prototype.map.call(
      form.querySelectorAll('button, input[type="submit"]'),
      function (element) {
        return getText(element.textContent || element.value);
      }
    ).join(' ');
    var formText = getText(form.textContent) + ' ' + submitText + ' ' + getText(form.getAttribute('action'));

    return (
      formText.indexOf('waitlist') !== -1 ||
      formText.indexOf('early access') !== -1 ||
      formText.indexOf('join') !== -1 ||
      formText.indexOf('newsletter') !== -1
    );
  }

  function hasSuccessSignal() {
    var params = new URLSearchParams(window.location.search);

    if (params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true') {
      return true;
    }

    var hash = getText(window.location.hash);

    if (
      hash.indexOf('contact_form') !== -1 ||
      hash.indexOf('newsletter') !== -1 ||
      hash.indexOf('customer_posted') !== -1
    ) {
      return true;
    }

    var successElement = document.querySelector(
      '.newsletter-form__message--success, .form-status, [data-form-status], [id*="Success"], [id*="success"], .success, .form__message'
    );

    if (!successElement) {
      return false;
    }

    var successText = getText(successElement.textContent);

    return (
      successText.indexOf('thank') !== -1 ||
      successText.indexOf('success') !== -1 ||
      successText.indexOf('posted') !== -1 ||
      successText.indexOf('received') !== -1 ||
      successText.indexOf('subscribed') !== -1
    );
  }

  function openModal() {
    if (!modal) {
      return;
    }

    applyModalContext();
    lastFocus = document.activeElement;
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sevenvn-waitlist-modal-open');

    if (dialog) {
      dialog.focus({ preventScroll: true });
    }
  }

  function closeModal() {
    if (!modal) {
      return;
    }

    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sevenvn-waitlist-modal-open');

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
  }

  function maybeShowModal() {
    if (sessionStorage.getItem(pendingKey) === '1' && hasSuccessSignal()) {
      sessionStorage.removeItem(pendingKey);
      openModal();

      if (observer) {
        observer.disconnect();
      }
    }
  }

  function showPendingFallback() {
    if (sessionStorage.getItem(pendingKey) === '1' && modal && !modal.classList.contains('is-visible')) {
      sessionStorage.removeItem(pendingKey);
      openModal();

      if (observer) {
      observer.disconnect();
      }
    }
  }

  function setFormSubmitting(form, isSubmitting) {
    Array.prototype.forEach.call(form.querySelectorAll('button, input[type="submit"]'), function (control) {
      if (isSubmitting) {
        control.disabled = true;
        control.setAttribute('aria-busy', 'true');
      } else {
        control.disabled = false;
        control.removeAttribute('aria-busy');
      }
    });
  }

  function submitWaitlistInBackground(form) {
    if (submittingForms && submittingForms.has(form)) {
      return;
    }

    if (submittingForms) {
      submittingForms.add(form);
    }

    storeWaitlistContext(form);
    setFormSubmitting(form, true);

    fetch(form.action || window.location.href, {
      method: (form.method || 'post').toUpperCase(),
      body: new FormData(form),
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html,application/xhtml+xml'
      },
      redirect: 'follow'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Waitlist submission failed.');
        }

        sessionStorage.removeItem(pendingKey);
        openModal();

        if (typeof form.reset === 'function') {
          form.reset();
        }
      })
      .catch(function () {
        sessionStorage.setItem(pendingKey, '1');
        window.setTimeout(showPendingFallback, 350);
      })
      .finally(function () {
        if (submittingForms) {
          submittingForms.delete(form);
        }

        setFormSubmitting(form, false);
      });
  }

  function bindModal() {
    modal = document.getElementById('SevenVNWaitlistSuccessModal');

    if (!modal) {
      return false;
    }

    dialog = modal.querySelector('.sevenvn-waitlist-modal__dialog');

    if (modal.dataset.sevenvnWaitlistBound !== 'true') {
      modal.dataset.sevenvnWaitlistBound = 'true';

      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-sevenvn-waitlist-close]')) {
          event.preventDefault();
          closeModal();
        }
      });
    }

    return true;
  }

  function initWaitlistModal() {
    if (initialized || !bindModal()) {
      return;
    }

    initialized = true;
    maybeShowModal();

    observer = new MutationObserver(maybeShowModal);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-visible')) {
        closeModal();
      }
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      if (isWaitlistForm(event.target)) {
        event.preventDefault();
        submitWaitlistInBackground(event.target);
      }
    },
    true
  );

  document.addEventListener('sevenvn:waitlist-success', function (event) {
    if (event.detail && event.detail.form) {
      storeWaitlistContext(event.detail.form);
    }

    sessionStorage.removeItem(pendingKey);
    openModal();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWaitlistModal);
  } else {
    initWaitlistModal();
  }
})();
